import { times } from 'lodash';
import Accounts from 'web3-eth-accounts';
import { asciiToHex, toDecimal, soliditySha3 } from 'web3-utils';

/**
 * Derive the v/r/s values from a given signature
 *
 * HERE BE DRAGONS
 * There is some weirdness between different versions of web3 or geth
 * where you may end up with +/- 27 here
 * Some implementations show v as slice(128, 2) + 27, but that never worked here
 * This derives the values needed to call ecrecover to verify the signature.
 * https://solidity.readthedocs.io/en/latest/units-and-global-variables.html#mathematical-and-cryptographic-functions
 *
 * @param {String} signature
 * @return {Object}
 */
export const deriveVrs = (signature) => {
  const r = `0x${signature.slice(0, 64)}`;
  const s = `0x${signature.slice(64, 128)}`;
  const v = toDecimal(signature.slice(128, 130));
  return { r, s, v };
};

const hash = (campaignId, i) =>
  soliditySha3({ type: 'bytes32', value: asciiToHex(campaignId) }, { type: 'uint256', value: i });

/**
 * Generates a bunch of verifiable codes that are signed with an ephemeral private key
 * The address is returned, along with the public key's derived address
 *
 * @param {String} campaignId
 * @param {Number} num - number of items to generate
 * @param {String?} entropy - optional additional entropy to pass to pk generator
 * @return {Object} - containing address and codes list
 */
export const generateKeyAndCodes = (campaignId, num, entropy = null) => {
  const account = new Accounts().create(entropy);
  const signatures = times(num, i => account.sign(hash(campaignId, i + 1)).signature.slice(2));

  return {
    address: account.address,
    codes: signatures,
  };
};

export const getSigner = (campaignId, num, signature) => {
  const accounts = new Accounts();
  return accounts.recover(hash(campaignId, num), `0x${signature}`);
};



// WEBPACK FOOTER //
// ./src/utilities/publicKeyCrypto.js